const brPriceTable = {
  priceTable: {
    label: {
      name: 'Nome',
      vendor: 'Fornecedor',
      category: 'Categoria',
      description: 'Descrição',
      preset: 'É pré-definido',
      createdAt: 'Criado em',
      document: 'Doc:',
      seeTablePrice: 'Ver tabela de preços',
    },

    table: {
      title: 'Tabela de preços',
      name: 'Nome',
      item: 'Item',
      category: 'Categoria',
      basePrice: 'Preço base',
      comboPrice: 'Preço combo',
      description: 'Descrição',
    },

    action: {
      cancel: 'Cancelar',
      edit: 'Editar tabela de preços',
      create: 'Criar  tabela de preços',
      delete: 'Apagar  tabela de preços',
      loading: 'Carregando  tabela de preços',
    },

    hints: {
      delete: 'Deseja mesmo apagar este item?',
    },

    messages: {
      successfullyCreated: 'Item criado com sucesso',
      successfullyUpdated: 'Item atualizado com sucesso',
      successfullyEdited: 'Item editado com sucesso',
      successfullyDeleted: 'Item removido com sucesso',
    },
  },
}

export default brPriceTable
